const Offerwall = ({img, bg, active, click, disabled, banned}) => {
    return (
        <>
            <div className={'wall-container ' + (active ? 'active' : '')} onClick={disabled || banned ? null : click}>
                <img src={img} alt='' draggable='false' style={{height: bg === 'whaleio' ? '100%': 'auto', width: bg === 'whaleio' ? '100%': '120px', objectFit: 'cover'}}/>
                
                <div className={'disabled ' + (disabled || banned ? 'active' : '')}>
                    {disabled ? <p>Temporarily Disabled</p> : banned ? <p>Banned</p> : null}
                </div>

                {bg === '#212528' && (
                    <div className="bonus-text">
                        25% bonus
                    </div>
                )}
            </div>

            <style jsx>
                {`
                    .wall-container {
                        height: 95px;
                        background: ${bg};
                        border-radius: 6px;

                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        cursor: pointer;
                        transition: transform .5s;

                        overflow: hidden;
                    }

                    .wall-container:hover {
                        transform: scale(0.98);
                    }

                    .wall-container.active {
                        border: 4px solid rgb(77, 169, 248);
                    }

                    .disabled {
                        display: none;
                        width: 100%;
                        height: 100%;
                        z-index: 1;
                        position: absolute;
                        left: 0;
                        top: 0;
                        background-color: rgba(0,0,0,.8);
                        font-weight: 600;
                        font-size: 1rem;
                        color: #4DAEFF;

                        align-items: center;
                        justify-content: center;
                        text-align: center;

                        user-select: none;
                    }

                    .disabled.active {
                        display: flex;
                    }

                    .bonus-text {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        font-size: 0.75rem;
                        color: #4DAEFF;
                        font-weight: 600;
                        background-color: rgba(0, 0, 0, 0.5);
                        padding: 2px 10px;
                        border-radius: 0 6px 0 0;
                        border-top: 1px solid rgba(255, 255, 255, 0.1);
                        border-right: 1px solid rgba(255, 255, 255, 0.1);
                    }
                `}
            </style>
        </>
    )
}

export default Offerwall